<main class="apply-page">

  <!-- =====================================================
       HERO
       ===================================================== -->

  <section class="apply-hero">

    <div class="apply-hero-inner">

      <div class="hero-eyebrow">

        <img
          [src]="branding.logoUrl()"
          alt=""
          class="hero-logo"
        />

        <span class="eyebrow-line"></span>

        <span>
          Careers
        </span>

      </div>

      <h1>
        Join the Team
      </h1>

      <p>
        Ready to get started?
        Choose how you'd like to apply.
      </p>

    </div>

  </section>


  <!-- =====================================================
       APPLICATION OPTIONS
       ===================================================== -->

  <section class="apply-content">

    <div class="apply-intro">

      <span class="section-kicker">
        Your Next Opportunity
      </span>

      <h2>
        Choose your path.
      </h2>

      <p>
        Explore current McDonald's opportunities through
        McHire or send a quick application directly to
        the local hiring team.
      </p>

    </div>


    <div class="application-options">

      <!-- =================================================
           CAREER PATH CARDS
           ================================================= -->

      <div class="career-path-grid">

        <!-- ===============================================
             McHIRE
             =============================================== -->

        <button
          type="button"
          class="career-path-card mchire-card"
          [class.active]="activeApplicationOption === 'mchire'"
          [attr.aria-expanded]="activeApplicationOption === 'mchire'"
          (click)="toggleApplicationOption('mchire')"
        >

          <div class="career-path-background">
            <span class="background-ring ring-one"></span>
            <span class="background-ring ring-two"></span>
          </div>


          <div class="career-path-top">

            <span class="career-path-badge">
              Official McDonald's Careers
            </span>

            <span class="career-path-arrow">
              <span>→</span>
            </span>

          </div>


          <div class="career-path-body">

            <div class="career-path-logo">

              <img
                [src]="branding.logoUrl()"
                alt=""
              />

            </div>


            <div class="career-path-copy">

              <span class="career-path-kicker">
                McHire
              </span>

              <h3>
                Apply Through McDonald's
              </h3>

              <p>
                Search current restaurant opportunities
                and complete your application through the
                official McDonald's careers platform.
              </p>

            </div>

          </div>


          <div class="career-path-footer">

            <span>
              Browse career opportunities
            </span>

            <span class="career-path-footer-line"></span>

          </div>

        </button>


        <!-- ===============================================
             DIRECT APPLY
             =============================================== -->

        <button
          type="button"
          class="career-path-card direct-card"
          [class.active]="activeApplicationOption === 'direct'"
          [attr.aria-expanded]="activeApplicationOption === 'direct'"
          (click)="toggleApplicationOption('direct')"
        >

          <div class="career-path-background">
            <span class="direct-glow"></span>
          </div>


          <div class="career-path-top">

            <span class="career-path-badge direct-badge">
              Local Quick Apply
            </span>

            <span class="career-path-arrow direct-arrow">
              <span>→</span>
            </span>

          </div>


          <div class="career-path-body">

            <div class="direct-symbol">
              <span></span>
              <span></span>
              <span></span>
            </div>


            <div class="career-path-copy">

              <span class="career-path-kicker">
                Apply Directly
              </span>

              <h3>
                Connect With Our Hiring Team
              </h3>

              <p>
                Skip the longer application process and
                send your information directly to the
                local team with our quick apply form.
              </p>

            </div>

          </div>


          <div class="career-path-footer">

            <span>
              Start your quick application
            </span>

            <span class="career-path-footer-line"></span>

          </div>

        </button>

      </div>


      <!-- =================================================
           McHIRE EXPANDED PANEL
           ================================================= -->

      <div
        class="career-expand-panel"
        [class.open]="activeApplicationOption === 'mchire'"
      >

        <div class="career-expand-inner">

          @if (activeApplicationOption === 'mchire') {

            <section class="mchire-feature">

              <div class="mchire-feature-decoration">

                <span class="mchire-circle circle-one"></span>

                <span class="mchire-circle circle-two"></span>

              </div>


              <div class="mchire-feature-copy">

                <span class="mchire-eyebrow">
                  Official McDonald's Careers
                </span>

                <h3>
                  Find the opportunity
                  that's right for you.
                </h3>

                <p>
                  Browse current McDonald's restaurant
                  openings, explore available positions,
                  and complete your application through
                  the official McDonald's careers platform.
                </p>


                <a
                  class="mchire-button"
                  href="https://careers.mcdonalds.com/jobs"
                  target="_blank"
                  rel="noopener"
                >

                  <span>
                    Browse Current Opportunities
                  </span>

                  <span class="mchire-button-arrow">
                    ↗
                  </span>

                </a>

              </div>


              <div
                class="mchire-feature-art"
                aria-hidden="true"
              >

                <div class="mchire-logo-display">

                  <img
                    [src]="branding.logoUrl()"
                    alt=""
                  />

                </div>

                <span class="mchire-domain">
                  careers.mcdonalds.com
                </span>

              </div>

            </section>

          }

        </div>

      </div>


      <!-- =================================================
           DIRECT APPLICATION EXPANDED PANEL
           ================================================= -->

      <div
        class="career-expand-panel"
        [class.open]="activeApplicationOption === 'direct'"
      >

        <div class="career-expand-inner">

          @if (activeApplicationOption === 'direct') {

            <form
              class="application-form"
              #applicationForm="ngForm"
              (ngSubmit)="submitApplication(applicationForm)"
            >

              <!-- =========================================
                   FORM HEADER
                   ========================================= -->

              <header class="form-header">

                <div>

                  <span class="section-kicker">
                    Quick Apply
                  </span>

                  <h3>
                    Tell us about yourself
                  </h3>

                  <p>
                    Complete the form below and your application
                    will be sent directly to the local hiring team.
                    A resume is welcome, but not required.
                  </p>

                </div>


                <span class="required-note">

                  <span>*</span>

                  Required fields

                </span>

              </header>


              <!-- =========================================
                   FORM BODY
                   ========================================= -->

              <div class="form-body">

                <div class="form-grid">

                  <!-- Location -->

                  <div class="form-field span-12">

                    <label for="location">
                      Restaurant Location
                      <span class="required">*</span>
                    </label>

                    <select
                      id="location"
                      name="locationId"
                      [(ngModel)]="applicationRequest.locationId"
                      required
                    >

                      <option
                        [ngValue]="null"
                        disabled
                      >
                        {{
                          locationsLoading
                            ? 'Loading locations...'
                            : 'Select a restaurant'
                        }}
                      </option>

                      @for (
                        location of locations;
                        track location.id
                      ) {

                        <option
                          [ngValue]="location.id"
                        >
                          {{ location.name }}
                        </option>

                      }

                    </select>

                  </div>


                  <!-- Position -->

                  <div class="form-field span-12">

                    <label for="position">
                      Position Applying For
                      <span class="required">*</span>
                    </label>

                    <select
                      id="position"
                      name="position"
                      [(ngModel)]="applicationRequest.position"
                      required
                    >

                      <option
                        value=""
                        disabled
                      >
                        Select a position
                      </option>

                      @for (
                        position of positions;
                        track position
                      ) {

                        <option
                          [value]="position"
                        >
                          {{ position }}
                        </option>

                      }

                    </select>

                  </div>


                  <!-- Name -->

                  <div class="form-field span-6">

                    <label for="firstName">
                      First Name
                      <span class="required">*</span>
                    </label>

                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      [(ngModel)]="applicationRequest.firstName"
                      required
                      autocomplete="given-name"
                      placeholder="First name"
                    />

                  </div>


                  <div class="form-field span-6">

                    <label for="lastName">
                      Last Name
                      <span class="required">*</span>
                    </label>

                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      [(ngModel)]="applicationRequest.lastName"
                      required
                      autocomplete="family-name"
                      placeholder="Last name"
                    />

                  </div>


                  <!-- Contact -->

                  <div class="form-field span-6">

                    <label for="phone">
                      Phone
                      <span class="required">*</span>
                    </label>

                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      [(ngModel)]="applicationRequest.phone"
                      required
                      autocomplete="tel"
                      placeholder="(555) 555-5555"
                    />

                  </div>


                  <div class="form-field span-6">

                    <label for="email">
                      Email
                      <span class="required">*</span>
                    </label>

                    <input
                      id="email"
                      name="email"
                      type="email"
                      [(ngModel)]="applicationRequest.email"
                      required
                      autocomplete="email"
                      placeholder="name@example.com"
                    />

                  </div>


                  <!-- Age -->

                  <div class="form-field span-12">

                    <label>
                      Age Eligibility
                      <span class="required">*</span>
                    </label>

                    <div class="selection-pills">

                      @for (
                        age of ageOptions;
                        track age
                      ) {

                        <label
                          class="selection-pill"
                          [class.selected]="applicationRequest.ageEligibility === age"
                        >

                          <input
                            type="radio"
                            name="ageEligibility"
                            [value]="age"
                            [(ngModel)]="applicationRequest.ageEligibility"
                          />

                          <span>
                            {{ age }}
                          </span>

                        </label>

                      }

                    </div>

                  </div>


                  <div class="form-field span-12">

                  <label>
                    Preferred Shifts
                    <span class="required">*</span>
                  </label>

                  <span class="field-help">
                    Select all that apply.
                  </span>

                  <div class="selection-pills">

                    @for (
                      shift of shiftOptions;
                      track shift
                    ) {

                      <button
                        type="button"
                        class="selection-pill button-pill"
                        [class.selected]="isShiftSelected(shift)"
                        (click)="toggleShift(shift)"
                      >
                        {{ shift }}
                      </button>

                    }

                  </div>

                </div>

                  <!-- Availability -->

                  <div class="form-field span-12">

                    <label>
                      Availability
                      <span class="required">*</span>
                    </label>

                    <span class="field-help">
                      Select the days you're generally available.
                    </span>

                    <div class="selection-pills">

                      @for (
                        availability of availabilityOptions;
                        track availability
                      ) {

                        <button
                          type="button"
                          class="selection-pill button-pill"
                          [class.selected]="isAvailabilitySelected(availability)"
                          (click)="toggleAvailability(availability)"
                        >
                          {{ availability }}
                        </button>

                      }

                    </div>

                  </div>


                  <!-- Referral Source -->

                  <div class="form-field span-12">

                    <label for="howHeard">
                      How did you hear about us?
                    </label>

                    <textarea
                      id="howHeard"
                      name="howHeard"
                      rows="3"
                      [(ngModel)]="applicationRequest.howHeard"
                      placeholder="Tell us how you found out about this opportunity..."
                    ></textarea>

                  </div>


                  <!-- Additional Information -->

                  <div class="form-field span-12">

                    <label for="additionalInformation">
                      Additional Information
                    </label>

                    <textarea
                      id="additionalInformation"
                      name="additionalInformation"
                      rows="4"
                      [(ngModel)]="applicationRequest.additionalInformation"
                      placeholder="Anything else you'd like the hiring team to know?"
                    ></textarea>

                  </div>


                  <!-- Resume -->

                  <div class="form-field span-12">

                    <label>

                      Resume

                      <span class="optional-label">
                        Optional
                      </span>

                    </label>


                    <div class="resume-upload">

                      <div class="resume-upload-copy">

                        <strong>
                          Attach a resume
                        </strong>

                        <p>
                          PDF, Word, or text file.
                          Maximum file size 8 MB.
                        </p>

                      </div>


                      <div class="resume-actions">

                        <label class="secondary-btn file-btn">

                          Choose File

                          <input
                            type="file"
                            accept=".pdf,.doc,.docx,.txt"
                            (change)="onResumeSelected($event)"
                          />

                        </label>


                        @if (selectedResumeName) {

                          <div class="selected-resume">

                            <span>
                              {{ selectedResumeName }}
                            </span>

                            <button
                              type="button"
                              (click)="removeResume()"
                              aria-label="Remove resume"
                            >
                              ×
                            </button>

                          </div>

                        }

                      </div>

                    </div>

                  </div>


                  <!-- Consent -->

                  <div class="form-field span-12">

                    <label class="consent-field">

                      <input
                        type="checkbox"
                        name="consentToContact"
                        [(ngModel)]="applicationRequest.consentToContact"
                        required
                      />

                      <span>
                        I consent to being contacted by phone,
                        text, or email regarding my application.
                        <strong>*</strong>
                      </span>

                    </label>

                  </div>

                </div>

              </div>


              <!-- =========================================
                   FORM FOOTER
                   ========================================= -->

              <footer class="form-footer">

                <p>
                  Your information will be sent directly
                  to the local hiring team.
                </p>

                <button
                  type="submit"
                  class="submit-button"
                  [disabled]="isSubmitting"
                >

                  @if (isSubmitting) {

                    <span class="spinner"></span>

                    Submitting...

                  } @else {

                    <span>
                      Submit Application
                    </span>

                    <span class="button-arrow">
                      →
                    </span>

                  }

                </button>

              </footer>

            </form>

          }

        </div>

      </div>

    </div>

  </section>

</main>
